import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';

export const apiDocsFr = createTranslationMessages({
  ref: apiDocsTranslationRef,
  full: true,
  messages: {
    'apiDefinitionCard.error.title': 'Impossible de récupérer l’API',
    'apiDefinitionCard.rawButtonTitle': 'Brut',
    'apiDefinitionDialog.closeButtonTitle': 'Fermer',
    'apiDefinitionDialog.tabsAriaLabel': 'Options de définition d’API',
    'apiDefinitionDialog.rawButtonTitle': 'Brut',
    'apiDefinitionDialog.toggleButtonAriaLabel':
      'Basculer la boîte de dialogue de définition d’API',
    'defaultApiExplorerPage.title': 'APIs',
    'defaultApiExplorerPage.subtitle': 'Explorateur d’API {{orgName}}',
    'defaultApiExplorerPage.pageTitleOverride': 'APIs',
    'defaultApiExplorerPage.createButtonTitle':
      'Enregistrer une API existante',
    'defaultApiExplorerPage.supportButtonTitle': 'Toutes vos APIs',
    'consumedApisCard.error.title': 'Impossible de charger les APIs',
    'consumedApisCard.title': 'APIs consommées',
    'consumedApisCard.emptyContent.title':
      'Ce {{entity}} ne consomme aucune API.',
    'hasApisCard.error.title': 'Impossible de charger les APIs',
    'hasApisCard.title': 'APIs',
    'hasApisCard.emptyContent.title': 'Ce {{entity}} ne contient aucune API.',
    'providedApisCard.error.title': 'Impossible de charger les APIs',
    'providedApisCard.title': 'APIs fournies',
    'providedApisCard.emptyContent.title':
      'Ce {{entity}} ne fournit aucune API.',
    'apiEntityColumns.typeTitle': 'Type',
    'apiEntityColumns.apiDefinitionTitle': 'Définition d’API',
    'consumingComponentsCard.error.title':
      'Impossible de charger les composants',
    'consumingComponentsCard.title': 'Consommateurs',
    'consumingComponentsCard.emptyContent.title':
      'Aucun composant ne consomme cette API.',
    'providingComponentsCard.error.title':
      'Impossible de charger les composants',
    'providingComponentsCard.title': 'Fournisseurs',
    'providingComponentsCard.emptyContent.title':
      'Aucun composant ne fournit cette API.',
    apisCardHelpLinkTitle: 'Découvrez comment modifier cela',
  },
});
